import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues, prepareValues } from '@/lib/values'

export const presentation_edit = {

  namespaced: true,

  state: {
    values: {},
    entities: [],
  },

  getters: {
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setValues(state, values) { state.values = values },
    setEntities(state, entities) { state.entities = entities },
  },

  actions: {

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Presentation'],
      form_display: true,
    }}),

    async getForm({ commit, dispatch }) {
      commit('clearResponse', {}, { root: true });
      commit('setEntities', []);
      const entities = await dispatch('getEntities');
      commit('setProgress', false, { root: true });
      commit('setValues', getValues('presentation', entities.data['App\\Models\\Presentation'], 'content'));
      commit('setEntities', entities.data['App\\Models\\Presentation']);
    },

    async validatePresentation({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Presentation', state.values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        let values = prepareValues(state.values, 'content_');
        dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Presentation', values);
      }
    },

    async createPresentation({ commit }, values) {
      const response = await Vue.axios.post(API_URL + '/presentations', values);
      commit('setProgress', false, { root: true });
      router.push('/presentation/' + response.data.id + '/edit');
      commit('setResponse', { status: true, type: 'success', message: 'presentation_successfully_created' }, { root: true });
    },

    async updatePresentation({ state, commit }, values) {
      const presentation = await Vue.axios.put(API_URL + '/presentations/' + router.currentRoute.params.id, values);
      commit('presentation/setPresentation', presentation.data, { root: true });
      commit('setValues', getValues('presentation', state.entities, 'content'));
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'presentation_successfully_updated' }, { root: true });
    },

  }
}
